import React, {
  memo,
  useMemo,
  useState,
  useCallback,
} from 'react';
import * as R from 'ramda';
// components
import { TextComponent } from '../../text';
// helpers
import * as G from '../../../helpers';
// ui
import { Box, ReactSelect } from '../../../ui';
// component edit-report
import { Option } from '../ui';
//////////////////////////////////////////////////

const OptionComponent = memo((props) => {
  const { data, action, selectOption, handleSelectOption } = props;

  return (
    <Option
      onClick={() => {
        selectOption(data);
        action(props);
        handleSelectOption();
      }}
    >
      {data.name}
    </Option>
  );
});

const ValueComponent = memo((props) => {
  const value = R.path(['data', 'name'], props);

  return (
    <TextComponent
      my={6}
      ml='8px'
      title={value}
      position='absolute'
      withEllipsis={true}
      width='calc(100% - 8px)'
    >
      {value}
    </TextComponent>
  );
});

export const FieldSelect = (({
  id,
  name,
  value,
  action,
  options,
  collection,
  fieldIndex,
  selectedOption,
  useMenuPortalTarget = true,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const selectedName = R.or(R.path(['name'], selectedOption), value);

  const handleOpenMenu = useCallback(() => setMenuIsOpen(true), []);
  const handleCloseMenu = useCallback(() => setMenuIsOpen(false), []);

  const components = useMemo(() => ({
    SingleValue: ValueComponent,
    Option: (props) => (
      <OptionComponent
        {...props}
        action={action}
        collection={collection}
        fieldIndex={fieldIndex}
        handleSelectOption={handleCloseMenu}
      />
    ),
  }), [action, collection, fieldIndex, handleCloseMenu]);

  return (
    <Box
      mx={10}
      width={232}
      // NOTE: react select menu doesn't open when user clicked on Control component
      cursor='auto'
      onKeyDown={G.stopPropagation}
      onPointerDown={G.stopPropagation}
    >
      {
        R.not(menuIsOpen) &&
        <Box
          bg='white'
          height={30}
          width='100%'
          cursor='pointer'
          border='1px solid'
          borderRadius='4px'
          position='relative'
          onClick={handleOpenMenu}
          borderColor={G.getTheme('colors.dark.grey')}
        >
          <TextComponent
            my={6}
            ml='8px'
            position='absolute'
            withEllipsis={true}
            title={selectedName}
            width='calc(100% - 8px)'
          >
            {selectedName}
          </TextComponent>
        </Box>
      }
      {
        menuIsOpen &&
        <ReactSelect
          id={id}
          name={name}
          height={30}
          action={action}
          autoFocus={true}
          options={options}
          isClearable={false}
          components={components}
          menuIsOpen={menuIsOpen}
          onBlurResetsInput={false}
          onSelectResetsInput={false}
          onMenuClose={handleCloseMenu}
          value={R.or(selectedOption, value)}
          useMenuPortalTarget={useMenuPortalTarget}
          shouldNotGetValueFromOptions={R.not(R.isNil(selectedOption))}
          closeMenuOnScroll={R.pathEq('edit_report_wrapper', ['target', 'id'])}
        />
      }
    </Box>
  );
});
